export default {
  title: '展示列',
  reset: '重置',
  groupLeftFixed: '左侧固定展示列',
  groupUnfixed: '未固定展示列',
  groupRightFixed: '右侧固定展示列',
  moveUp: '上移',
  moveDown: '下移',
  leftFull: '左侧固定列最多 {max} 个',
  rightFull: '右侧固定列最多 {max} 个',
  rightLocked: '右侧固定列不可修改',
  saveFailed: '列设置保存失败',
  count: '{current}/{max}',
}
